module.exports = __webpack_public_path__ + "img/Coral-Logo-Light.30ac6a6e.svg";